import { env } from "@/config/env";

const STAFF_EMAIL_DOMAIN = env.VITE_STAFF_EMAIL_DOMAIN || "naud-staff.local";

/**
 * What a person types to log in. Staff without a real email get a
 * staff-domain address and log in with the part before the "@"; everyone else
 * logs in with their full email.
 */
export function staffUsername(
  email: string,
  staffDomain: string = STAFF_EMAIL_DOMAIN,
): string {
  const suffix = `@${staffDomain}`;
  if (!email.toLowerCase().endsWith(suffix.toLowerCase())) {
    return email;
  }
  return email.slice(0, -suffix.length);
}
